(function () {
  var STORAGE_KEY = "vlTimerDiscountOffer";
  var DEFAULT_ENDPOINT = "/apps/timer-discount/start";
  var activeTimer = null;

  function now() {
    return Date.now();
  }

  function parseJson(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function readStoredOffer() {
    return parseJson(window.localStorage.getItem(STORAGE_KEY) || "");
  }

  function storeOffer(offer) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(offer));
  }

  function clearOffer() {
    window.localStorage.removeItem(STORAGE_KEY);
  }

  function getProductConfig() {
    var node = document.querySelector("[data-vl-timer-discount-config]");
    return node ? parseJson(node.textContent) : null;
  }

  function expiresAtMs(offer) {
    return offer && offer.expiresAt ? Date.parse(offer.expiresAt) : 0;
  }

  function isOfferActive(offer) {
    return Boolean(offer && offer.code && expiresAtMs(offer) > now());
  }

  function sameProduct(offer, config) {
    if (!offer || !config) return false;
    return String(offer.productId) === String(config.productId) || String(offer.productGid) === String(config.productGid);
  }

  function formatTime(ms) {
    var totalSeconds = Math.max(0, Math.floor(ms / 1000));
    var minutes = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
    var seconds = String(totalSeconds % 60).padStart(2, "0");
    return minutes + ":" + seconds;
  }

  function setHidden(nodes, hidden) {
    nodes.forEach(function (node) {
      node.hidden = hidden;
    });
  }

  function setPdpSaleBadgeHidden(hidden) {
    document.querySelectorAll("[data-vl-timer-discount-badge]").forEach(function (badge) {
      var wrapper = badge.closest(".m-price__badges");
      if (!wrapper) return;
      wrapper.querySelectorAll(".m-price__badge-sale").forEach(function (saleBadge) {
        saleBadge.hidden = hidden;
      });
    });

    document.querySelectorAll(".product-block-group--price .m-price__badge-sale").forEach(function (saleBadge) {
      saleBadge.hidden = hidden;
    });
  }

  function renderOffer(offer) {
    var remaining = expiresAtMs(offer) - now();
    var active = isOfferActive(offer);
    var badges = Array.from(document.querySelectorAll("[data-vl-timer-discount-badge]"));
    var cartBadges = Array.from(document.querySelectorAll("[data-vl-timer-discount-cart]"));
    var allBadges = badges.concat(cartBadges);

    if (!active) {
      clearOffer();
      setHidden(allBadges, true);
      setPdpSaleBadgeHidden(false);
      stopTimer();
      return;
    }

    setPdpSaleBadgeHidden(true);
    allBadges.forEach(function (badge) {
      badge.hidden = false;
      badge.querySelectorAll("[data-vl-timer-discount-percent]").forEach(function (node) {
        node.textContent = String(offer.percent);
      });
      badge.querySelectorAll("[data-vl-timer-discount-time]").forEach(function (node) {
        node.textContent = formatTime(remaining);
      });
    });
  }

  function stopTimer() {
    if (activeTimer) {
      window.clearInterval(activeTimer);
      activeTimer = null;
    }
  }

  function startTimer(offer) {
    stopTimer();
    renderOffer(offer);
    activeTimer = window.setInterval(function () {
      renderOffer(offer);
    }, 1000);
  }

  function attachOfferProperties(offer) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      [
        ["properties[_timer_discount_code]", offer.code],
        ["properties[_timer_discount_expires_at]", offer.expiresAt],
        ["properties[_timer_discount_percent]", String(offer.percent)]
      ].forEach(function (entry) {
        var input = form.querySelector('input[name="' + entry[0] + '"]');
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = entry[0];
          form.appendChild(input);
        }
        input.value = entry[1];
      });
    });
  }

  function removeOfferProperties() {
    document.querySelectorAll('form[action*="/cart/add"] input[name^="properties[_timer_discount_"]').forEach(function (input) {
      input.remove();
    });
  }

  function requestOffer(config) {
    return window.fetch(config.endpoint || DEFAULT_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        productId: config.productId,
        productGid: config.productGid,
        variantId: config.variantId,
        variantGid: config.variantGid,
        handle: config.handle,
        vendor: config.vendor,
        percent: config.percent,
        durationSeconds: config.durationSeconds
      })
    }).then(function (response) {
      if (!response.ok) throw new Error("Timer discount endpoint failed");
      return response.json();
    }).then(function (offer) {
      if (!offer || !offer.code || !offer.expiresAt) throw new Error("Timer discount endpoint returned an invalid offer");
      return {
        code: offer.code,
        expiresAt: offer.expiresAt,
        percent: offer.percent || config.percent,
        productId: config.productId,
        productGid: config.productGid,
        variantId: config.variantId,
        variantGid: config.variantGid
      };
    });
  }

  function cartHasOfferProduct(cart, offer) {
    if (!cart || !cart.items || !offer) return false;
    return cart.items.some(function (item) {
      return String(item.product_id) === String(offer.productId) || String(item.vendor || "").toLowerCase() === "haida";
    });
  }

  function refreshCartOffer() {
    var offer = readStoredOffer();
    if (!isOfferActive(offer)) {
      renderOffer(offer);
      return;
    }

    window.fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart.js", {
      headers: { "Accept": "application/json" }
    }).then(function (response) {
      return response.json();
    }).then(function (cart) {
      if (cartHasOfferProduct(cart, offer)) {
        startTimer(offer);
      } else {
        setHidden(Array.from(document.querySelectorAll("[data-vl-timer-discount-cart]")), true);
      }
    }).catch(function () {
      renderOffer(offer);
    });
  }

  function applyDiscountAndCheckout(event) {
    var submitter = event.submitter || document.activeElement;
    if (!submitter || submitter.getAttribute("name") !== "checkout") return;

    var offer = readStoredOffer();
    if (!isOfferActive(offer)) {
      clearOffer();
      return;
    }

    event.preventDefault();
    var redirect = encodeURIComponent("/checkout");
    window.location.href = "/discount/" + encodeURIComponent(offer.code) + "?redirect=" + redirect;
  }

  function initProductOffer() {
    var config = getProductConfig();
    if (!config || !config.enabled) return;

    var stored = readStoredOffer();
    if (isOfferActive(stored) && sameProduct(stored, config)) {
      attachOfferProperties(stored);
      startTimer(stored);
      return;
    }

    requestOffer(config).then(function (offer) {
      storeOffer(offer);
      attachOfferProperties(offer);
      startTimer(offer);
    }).catch(function () {
      removeOfferProperties();
      setHidden(Array.from(document.querySelectorAll("[data-vl-timer-discount-badge]")), true);
    });
  }

  function initStyles() {
    if (document.getElementById("vl-timer-discount-styles")) return;
    var style = document.createElement("style");
    style.id = "vl-timer-discount-styles";
    style.textContent = [
      ".vl-timer-discount-badge,.vl-timer-discount-cart{display:inline-flex;align-items:center;gap:6px;border:1px solid rgba(17,24,39,.16);border-radius:999px;background:#fff;color:#111827;font-size:12px;font-weight:600;line-height:1;padding:8px 10px;white-space:nowrap}",
      ".vl-timer-discount-badge[hidden],.vl-timer-discount-cart[hidden]{display:none!important}",
      ".vl-timer-discount-badge--standalone{margin-top:8px}",
      ".vl-timer-discount-cart{margin:0 16px 14px;justify-content:center;width:calc(100% - 32px)}",
      ".vl-timer-discount-cart strong{font-weight:700}",
      ".vl-timer-discount-time{font-variant-numeric:tabular-nums}"
    ].join("");
    document.head.appendChild(style);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initStyles();
    initProductOffer();
    refreshCartOffer();

    document.addEventListener("submit", applyDiscountAndCheckout, true);

    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, refreshCartOffer);
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openCartDrawer, refreshCartOffer);
    }

    window.addEventListener("storage", function (event) {
      if (event.key === STORAGE_KEY) refreshCartOffer();
    });
  });
})();
